<template>
    <div>
        <headerNav title="全部回答" />
        <div class="qmian" v-if="vinfo">
            <div class="qheader">
                <div class="qheader-tit">
                    {{vinfo.title}}
                </div>
                <div class="qheader-stit" v-if="vinfo.signature">
                    {{vinfo.signature}}
                </div>
                <div class="qheader-content">
                    {{vinfo.content}}
                </div>
            </div>
            <div class="qanswer" v-if="totalnum!=undefined">
                {{totalnum}}个回答
            </div>
            
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                v-model="navitem.loaded"
                :finished="navitem.loadingType == 'nomore' ? true : false"
                @load="loadData"
                >
                    <div v-for="(item,index) in navitem.list" :key="index" class="answerlist">
                        <comanswerlist :item="item" @like="like" :showicons="true" :title="vinfo.title" ></comanswerlist>
                    </div>
                    
                </van-list>
            </van-pull-refresh>

        </div>

        <div class="qfooter" @click="gotoanswer">
            <div >
               <van-icon
                    class="answerlist-icon-icon3"
                    :size="18"
                    class-prefix="abc-icon"
                    name="xieru"
                />
                <span class="qfooter-tit">我来回答</span>
            </div>
        </div>
    </div>
</template>
<script>
import comanswerlist from '@/components/common/answer/comanswerlist.vue';
export default {
    components:{
        comanswerlist
    },
    data(){
        return{
            vid:undefined,
            vinfo:undefined,
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: "",
                    maxResultCount: 10,
                    skipCount: 0,
                    questionId:undefined
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
            totalnum:undefined
        }
    },
    created(){
      var query=this.$route.query;
      this.navitem.getparams.questionId=query.id;
      this.vinfo=JSON.parse(query.item);
    },  
    methods:{
    like(item)
    {
       
        var vindex=this.navitem.list.findIndex(x=>x.id==item.id);
        if(!item.isLike)
        {
            var model={
                questionId:item.questionId,
                questionAnswersId:item.id
            };
            this.ajax.post('/api/services/app/PhoneQuestion/LikeAnswer',model).then(x=>{
                this.navitem.list[vindex].isLike=true;
                this.navitem.list[vindex].giveLikeCount+=1;
            })
        }
        else
        {
            this.ajax.post('/api/services/app/PhoneQuestion/CancelLikeAnswer?questionAnswersId='+item.id).then(x=> {
                this.navitem.list[vindex].isLike=false;
                this.navitem.list[vindex].giveLikeCount-=1;
            })
        }
        
        
    },
    gotoanswer(){
        this.$router.push({path:'/addanswer',query:{title:this.vinfo.title,id:this.vinfo.id}});
    },
    onRefresh() {
      this.loadData("refresh");
    },
    loadData(source) {
      let navItem = this.navitem;
      
      if (source === "tabChange" && navItem.loaded === true) {
        //tab切换只有第一次需要加载数据
        return;
      }
      if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
        //防止重复加载
        if (source != "refresh") {
          return;
        }
      }
      if (source === "refresh") {
        this.navitem.list = [];
        this.navitem.getparams.skipCount = 0;
      }
      navItem.loadingType = "loading";
      var params = navItem.getparams;
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneQuestion/QueryAnswerQuestion", params)
        .then((x) => {
          this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.totalnum=x.result.totalCount;
          this.navitem.list = this.navitem.list.concat(x.result.items);
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.navitem.loadingType =
            totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
        })
        .finally(() => {
          this.$set(this.navitem, "loaded", false);
          this.refreshing = false;
        });
    },
    }
}
</script>
<style lang="scss" scoped>
.qmian{
    font-size: 13px;
    line-height: 22px;
    margin-bottom: 50px;
}
.qheader{
    padding:10px 20px 5px 20px;
    background-color: #fff;
}
.qheader-tit{
    font-size: 16px;
    font-weight: bold;
}
.qheader-stit{
    color:#a8a8a8;
}
.qheader-content{
    margin-top:5px;
}
.qanswer{
    padding: 10px 20px;
}

.answerlist{
    padding: 5px 20px;
    background-color: #fff;
    font-size: 14px;
}
.answerlist:first-child{
    padding-top:10px;
}



.qfooter{
    position: fixed;
    bottom: 0;
    left:0;
    right:0;
    background-color: #fff;
    text-align: center;
    padding: 15px;
    font-size: 15px;
    color:#e4c469;
    border-top:1px solid #e6e6e6;
    .qfooter-tit{
        margin-left:5px;
    }
}

</style>